import Vue from 'vue'
import Router from 'vue-router'

import store from '@/store'

/***** pages *****/
import Root from '@/components/pages/Root.vue'

//service
import ServiceIndex from '@/components/pages/service/Index.vue'
import ServiceAbout from '@/components/pages/service/About.vue'
import ServiceContact from '@/components/pages/service/Contact.vue'
import ServiceFeatures from '@/components/pages/service/Features.vue'
import ServicePlans from '@/components/pages/service/Plans.vue'
import IndexServiceNotifications from '@/components/pages/service/notifications/Index.vue'
import ShowServiceNotifications from '@/components/pages/service/notifications/Show.vue'
import ServicePrivacyPolicy from '@/components/pages/service/PrivacyPolicy.vue'
import ServiceTermsOfService from '@/components/pages/service/TermsOfService.vue'

// auth
import InviteUser from '@/components/pages/InviteUser.vue'
import ForgotPassword from '@/components/pages/ForgotPassword.vue'
import ResetPassword from '@/components/pages/ResetPassword.vue'
import SignIn from '@/components/pages/SignIn.vue'
import SignUp from '@/components/pages/SignUp.vue'
import Confirmation from '@/components/pages/Confirmation.vue'
import ResendConfirmation from '@/components/pages/ResendConfirmation.vue'

// myspace
import MySpace from '@/components/pages/MySpace.vue'

// chat
import IndexChat from '@/components/pages/chat/Index.vue'
import NewChat from '@/components/pages/chat/New.vue'
import ShowChat from '@/components/pages/chat/Show.vue'
import EditChat from '@/components/pages/chat/Edit.vue'

// meeting
import IndexMeeting from '@/components/pages/meeting/Index.vue'
import GuestMeeting from '@/components/pages/meeting/Guest.vue'
import GuestMeetingThanks from '@/components/pages/service/Thanks.vue'
import IndexMeetingReservations from '@/components/pages/meeting/reservations/Index.vue'
import NewMeetingReservations from '@/components/pages/meeting/reservations/New.vue'
import ShowMeetingReservations from '@/components/pages/meeting/reservations/Show.vue'
import EditMeetingReservations from '@/components/pages/meeting/reservations/Edit.vue'
import IndexRoom from '@/components/pages/meeting/reservations/room/Index.vue'

// member
import IndexMember from '@/components/pages/member/Index.vue'
import ShowMember from '@/components/pages/member/Show.vue'

// project
import IndexProject from '@/components/pages/project/Index.vue'
import NewProject from '@/components/pages/project/New.vue'
import ShowProject from '@/components/pages/project/Show.vue'
import EditProject from '@/components/pages/project/Edit.vue'
import NewProjectTaskCards from '@/components/pages/project/taskCards/New.vue'
import ShowProjectTaskCards from '@/components/pages/project/taskCards/Show.vue'
// import EditProjectTaskCards from '@/components/pages/project/taskCards/Edit.vue'

// management
import IndexManagement from '@/components/pages/management/Index.vue'
import IndexManagementMembers from '@/components/pages/management/members/Index.vue'
import ShowManagementMembers from '@/components/pages/management/members/Show.vue'
import ShowInvitedMembers from '@/components/pages/management/invitedMembers/Show.vue'
import IndexManagementMeetingRooms from '@/components/pages/management/meetingRooms/Index.vue'
import IndexManagementOrganization from '@/components/pages/management/organization/Index.vue'
import IndexManagementLicensePlan from '@/components/pages/management/licensePlan/Index.vue'
import EditManagementLicensePlan from '@/components/pages/management/licensePlan/Edit.vue'
import IndexManagementBillingHistories from '@/components/pages/management/billingHistories/Index.vue'
import ShowManagementBillingHistories from '@/components/pages/management/billingHistories/Show.vue'
import IndexManagementPaymentMethod from '@/components/pages/management/paymentMethod/Index.vue'

// errors
import NotFound from '@/components/pages/errors/NotFound.vue'

/*****************/

Vue.use(Router)

const routes = [
  { path: '/', name: 'root', component: Root, meta: { requires: { disableNavigation: true } } },
  { path: '/service', name: 'service', component: ServiceIndex, meta: { requires: { disableNavigation: true }, menu: 'service' } },
  { path: '/service/about', name: 'serviceAbout', component: ServiceAbout, meta: { requires: { disableNavigation: true }, menu: 'service' } },
  { path: '/service/contact', name: 'serviceContact', component: ServiceContact, meta: { requires: { disableNavigation: true }, menu: 'service' } },
  { path: '/service/features', name: 'serviceFeatures', component: ServiceFeatures, meta: { requires: { disableNavigation: true }, menu: 'service' } },
  { path: '/service/plans', name: 'servicePlans', component: ServicePlans, meta: { requires: { disableNavigation: true }, menu: 'service' } },
  { path: '/service/notifications', name: 'indexServiceNotifications', component: IndexServiceNotifications, meta: { requires: { disableNavigation: true }, menu: 'service' } },
  { path: '/service/notifications/:id', name: 'showServiceNotifications', component: ShowServiceNotifications, meta: { requires: { disableNavigation: true }, menu: 'service' } },
  { path: '/service/privacy_policy', name: 'servicePrivacyPolicy', component: ServicePrivacyPolicy, meta: { requires: { disableNavigation: true }, menu: 'service' } },
  { path: '/service/terms', name: 'serviceTermsOfService', component: ServiceTermsOfService, meta: { requires: { disableNavigation: true }, menu: 'service' } },
  { path: '/invite_user', name: 'inviteUser', component: InviteUser, meta: { requires: { disableNavigation: true } } },
  { path: '/forgot_password', name: 'forgotPassword', component: ForgotPassword, meta: { requires: { authentication: false, disableNavigation: true } } },
  { path: '/reset_password', name: 'resetPassword', component: ResetPassword, meta: { requires: { authentication: false, disableNavigation: true } } },
  { path: '/sign_in', name: 'signIn', component: SignIn, meta: { requires: { authentication: false, disableNavigation: true } } },
  { path: '/sign_up', name: 'signUp', component: SignUp, meta: { requires: { authentication: false, disableNavigation: true } } },
  { path: '/confirmation', name: 'confirmation', component: Confirmation, meta: { requires: { authentication: false, disableNavigation: true } } },
  { path: '/resend_confirmation', name: 'resendConfirmation', component: ResendConfirmation, meta: { requires: { authentication: false, disableNavigation: true } } },
  { path: '/my_space', name: 'mySpace', component: MySpace, meta: { requires: { authentication: true }, menu: 'mySpace' } },
  { path: '/chat', name: 'chat', component: IndexChat, meta: { requires: { authentication: true }, menu: 'chat' } },
  { path: '/chat/new', name: 'newChat', component: NewChat, meta: { requires: { authentication: true }, menu: 'chat' } },
  { path: '/chat/:id', name: 'showChat', component: ShowChat, meta: { requires: { authentication: true }, menu: 'chat', sidebar: 'collapsed' } },
  { path: '/chat/:id/edit', name: 'editChat', component: EditChat, meta: { requires: { authentication: true }, menu: 'chat', sidebar: 'collapsed' } },
  { path: '/meeting', name: 'meeting', component: IndexMeeting, meta: { requires: { authentication: true }, menu: 'meeting' } },
  { path: '/meeting/guest', name: 'guestMeeting', component: GuestMeeting, meta: { requires: { disableNavigation: true }, menu: 'meeting' } },
  { path: '/meeting/guest/room', name: 'guestMeetingRoom', component: IndexRoom, meta: { requires: { disableNavigation: true }, menu: 'videoRoom' } },
  { path: '/meeting/guest/thanks', name: 'guestMeetingThanks', component: GuestMeetingThanks, meta: { requires: { disableNavigation: true }, menu: 'service' } },
  { path: '/meeting/:id/reservations', name: 'indexMeetingReservations', component: IndexMeetingReservations, meta: { requires: { authentication: true }, menu: 'meeting' } },
  { path: '/meeting/:id/reservations/new', name: 'newMeetingReservations', component: NewMeetingReservations, meta: { requires: { authentication: true }, menu: 'meeting' } },
  { path: '/meeting/:videoRoomMasterId/reservations/:id', name: 'showMeetingReservations', component: ShowMeetingReservations, meta: { requires: { authentication: true }, menu: 'meeting' } },
  { path: '/meeting/:videoRoomMasterId/reservations/:id/edit', name: 'editMeetingReservations', component: EditMeetingReservations, meta: { requires: { authentication: true }, menu: 'meeting' } },
  { path: '/meeting/:videoRoomMasterId/reservations/:id/room', name: 'indexRoom', component: IndexRoom, meta: { requires: { authentication: true, disableNavigation: true }, menu: 'videoRoom' } },
  { path: '/member', name: 'member', component: IndexMember, meta: { requires: { authentication: true }, menu: 'member' } },
  { path: '/member/:id', name: 'showMember', component: ShowMember, meta: { requires: { authentication: true }, menu: 'member' } },
  { path: '/project', name: 'project', component: IndexProject, meta: { requires: { authentication: true }, menu: 'project' } },
  { path: '/project/new', name: 'newProject', component: NewProject, meta: { requires: { authentication: true }, menu: 'project' } },
  { path: '/project/:id', name: 'showProject', component: ShowProject, meta: { requires: { authentication: true }, menu: 'project' } },
  { path: '/project/:id/edit', name: 'editProject', component: EditProject, meta: { requires: { authentication: true }, menu: 'project' } },
  { path: '/project/:id/task_cards/new', name: 'newProjectTaskCards', component: NewProjectTaskCards, meta: { requires: { authentication: true }, menu: 'project' } },
  { path: '/project/:projectId/task_cards/:id', name: 'showProjectTaskCards', component: ShowProjectTaskCards, meta: { requires: { authentication: true }, menu: 'project' } },
  // { path: '/project/:projectId/task_cards/:id/edit', name: 'editProjectTaskCards', component: EditProjectTaskCards, meta: { requires: { authentication: true }, menu: 'project' } },
  { path: '/management', name: 'management', component: IndexManagement, meta: { requires: { authentication: true }, menu: 'management' } },
  { path: '/management/members', name: 'indexManagementMembers', component: IndexManagementMembers, meta: { requires: { authentication: true }, menu: 'management' } },
  { path: '/management/members/:id', name: 'showManagementMembers', component: ShowManagementMembers, meta: { requires: { authentication: true }, menu: 'management' } },
  { path: '/management/invited_members/:id', name: 'showInvitedMembers', component: ShowInvitedMembers, meta: { requires: { authentication: true }, menu: 'management' } },
  { path: '/management/meeting_rooms', name: 'indexManagementMeetingRooms', component: IndexManagementMeetingRooms, meta: { requires: { authentication: true }, menu: 'management' } },
  { path: '/management/organization', name: 'indexManagementOrganization', component: IndexManagementOrganization, meta: { requires: { authentication: true }, menu: 'management' } },
  { path: '/management/license_plan', name: 'indexManagementLicensePlan', component: IndexManagementLicensePlan, meta: { requires: { authentication: true }, menu: 'management' } },
  { path: '/management/license_plan/edit', name: 'editManagementLicensePlan', component: EditManagementLicensePlan, meta: { requires: { authentication: true }, menu: 'management' } },
  { path: '/management/billing_histories', name: 'indexManagementBillingHistories', component: IndexManagementBillingHistories, meta: { requires: { authentication: true }, menu: 'management' } },
  { path: '/management/billing_histories/:id', name: 'showManagementBillingHistories', component: ShowManagementBillingHistories, meta: { requires: { authentication: true }, menu: 'management' } },
  { path: '/management/payment_method', name: 'indexManagementPaymentMethod', component: IndexManagementPaymentMethod, meta: { requires: { authentication: true }, menu: 'management' } },
  // errors
  { path: '*', name: 'notFound', component: NotFound }
]

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior() {
    return { x: 0, y: 0 }
  }
})

const configureNext = ({ next, name, menu, query }) => {
  store.dispatch('changeMenu', menu ? menu : null)
  if (menu === 'management' && store.getters['auth/currentOrganization'].adminUserId !== store.getters['auth/signedInUser'].id) {
    store.commit('setForbidden', true)
    next()
  } else if (menu === 'project' && !store.getters['auth/currentLicensedPlan'].allowProjects) {
    store.commit('setForbidden', true)
    next()
  } else if (name) {
    next({ name: name, query: query })
  } else {
    next()
  }
}

router.beforeEach((to, _, next) => {
  store.dispatch('clearHttpStatus')
  store.dispatch('clearComponentStatus')
  const toRouteRequires = Object.assign({}, to.matched[0].meta.requires)
  const toRouteMenu = to.matched[0].meta.menu
  const decide = () => {
    if (toRouteRequires.authentication === true) {
      if (!store.getters['auth/signedInUser']) {
        configureNext({ next: next, name: 'signIn', query: { redirect: to.fullPath } })
      } else if (!store.getters['auth/currentOrganization'] || !store.getters['auth/currentOrganization'].isActivated) {
        store.commit('setUnusable', true)
      } else {
        configureNext({ next: next, menu: toRouteMenu })
      }
    } else if (toRouteRequires.authentication === false && store.getters['auth/signedInUser']) {
      configureNext({ next: next, name: 'mySpace', menu: toRouteMenu })
    } else {
      configureNext({ next: next, menu: toRouteMenu })
    }
  }
  if (store.getters['auth/initialized']) {
    decide()
  } else {
    const unwatch = store.watch((_, getters) => getters['auth/initialized'], () => {
      unwatch()
      decide()
    })
  }
})

export default router
